import React from 'react';

import { AppContext } from '../contexts';

export const useCatchHttpError = (): ((err: any) => void) => {
  const { addAlert } = React.useContext(AppContext);

  const catchError = (err: any): void => {
    if (err.response) {
      const responseData = err.response.data;
      if (responseData.title || responseData.message) {
        addAlert({
          message: responseData.title ?? responseData.message,
          variant: 'error'
        });
      }
    } else if (err.message) {
      addAlert({
        message: err.message,
        variant: 'error'
      });
    }
  };

  return catchError;
};
